import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SAT_BASIC_03_Schema } from './SAT_BASIC_03_Schema';
import { useSelector } from 'react-redux';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(SAT_BASIC_03_Schema.mapper.search1);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const query = useQuery({
    queryKey: ['SafetyHealthTraining', 'getSatBasic03R1', params],
    queryFn: () =>
      apiRequest(
        'post',
        Global.urls.SafetyHealthTraining.getSatBasic03R1,
        params
      ),
    enabled: !!searchInfo?.custCd,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_03_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.saveSatBasic03U1,
      payload
    );
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAT_BASIC_03_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.SafetyHealthTraining.deleteSatBasic03D1,
      payload
    );
  }, options);
};
